import { pluginApi } from 'services/api';


export default async (getValuesProducerId: number) => {
  
  const { data } = await pluginApi.get(
    `/participants/produtor/getProdutorInfo?idProducer=${getValuesProducerId}`,
  );
  return data;
};